import React, { useEffect, useLayoutEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import LoginPage from "./pages/LoginPage";

import NegotiationResponsesPage from "./pages/NegotiationResponsesPage";
import DashboardPage from "./pages/DashboardPage";
import AlertsPage from "./pages/AlertsPage";
import ProjectSummaryPage from "./pages/ProjectSummaryPage";
import InvestorReportPage from "./pages/InvestorReportPage";
import ProjectsPage from "./pages/ProjectsPage";
import ClientsPage from "./pages/ClientsPage";
import ConstructorsPage from "./pages/ConstructorsPage";
import MilestonesPage from "./pages/MilestonesPage";
import DocumentsPage from "./pages/DocumentsPage";
import ProcessYomaPage from "./pages/ProcessYomaPage";
import FinancePage from "./pages/FinancePage";
import PaymentSchedulePage from "./pages/PaymentSchedulePage";
import ProjectFinancialDashboardPage from "./pages/ProjectFinancialDashboardPage";
import YomaKnowledgePage from "./pages/YomaKnowledgePage";
import AcquisitionClientPage from "./pages/AcquisitionClientPage";
import ListePrequalificationsPage from "./pages/ListePrequalificationsPage";
import StrategicDossierPage from "./pages/StrategicDossierPage";
import ProjetArchitectureInterieure from "./pages/ProjetArchitectureInterieure";
import MissionOPC from "./pages/MissionOPC";
import MissionMandataire from "./pages/MissionMandataire";
import MissionAMO from "./pages/MissionAMO";
import MissionConducteurTravaux from "./pages/MissionConducteurTravaux";
import HypothesesRisquesPage from "./pages/HypothesesRisquesPage";
import DecisionFinalePage from "./pages/DecisionFinalePage";
import ClientIdentityPage from "./pages/ClientIdentityPage";
import ProjectSimulationPage from "./pages/ProjectSimulationPage";
import MultiVillaSimulationPage from "./pages/MultiVillaSimulationPage";
import ScenarioSimulationPage from "./pages/ScenarioSimulationPage";
import ProposalPage from "./pages/ProposalPage";
import PropositionContractuellePage from "./pages/PropositionContractuellePage";
import PropositionsPage from "./pages/PropositionsPage";
import AnnexesClausesPage from "./pages/AnnexesClausesPage";
import SignatureProjectPage from "./pages/SignatureProjectPage";
import ContractGeneratorPage from "./pages/ContractGeneratorPage";
import ContratAcquereurPage from "./pages/ContratAcquereurPage";
import DashboardPromotionPage from "./pages/DashboardPromotionPage";
import SuiviVentesPage from "./pages/SuiviVentesPage";
import AppelsPaiementPage from "./pages/AppelsPaiementPage";
import ContractAIGeneratorPage from "./pages/ContractAIGeneratorPage";
import ContractClientPage from "./pages/ContractClientPage";
import BrandingSettingsPage from "./pages/BrandingSettingsPage";
import UsersManagementPage from "./pages/UsersManagementPage";
import NotificationBell from "./components/NotificationBell";
import OnboardingModal from "./components/OnboardingModal";
import HelpButton from "./components/HelpButton";
import UpgradePage from "./pages/UpgradePage";
import PVChantierPage from "./pages/PVChantierPage";
import ClientDashboardPage from "./pages/ClientDashboardPage";
import EntrepriseDashboardPage from "./pages/EntrepriseDashboardPage";
import EntreprisePage from "./pages/EntreprisePage";
import GanttPage from "./pages/GanttPage";
import MessagerPage from "./pages/MessagerPage";
import KanbanPage from "./pages/KanbanPage";
import FormulaireProspectPage from "./pages/FormulaireProspectPage";
import PreConsultationsPage from "./pages/PreConsultationsPage";
import DecisionPage from "./pages/DecisionPage";
import PreConsultationPublic from "./pages/PreConsultationPublic";
import { usePlan } from "./hooks/usePlan";
import PlanGate from "./components/PlanGate";
import { useDevice } from "./hooks/useDevice";
import MobileNav from "./components/MobileNav";
import { useOfflineDevis } from "./hooks/useOfflineDevis";
import FFEPage from "./pages/FFEPage";
import EstimatorPage from "./pages/EstimatorPage";
import VisualisationTemporelleAIPage from "./pages/VisualisationTemporelleAIPage";
import DevisIntelligentPage from "./pages/DevisIntelligentPage";

const GOLD     = "#C9A96E";
const TAUPE    = "#B5B0A8";
const WHITE    = "#FFFFFF";
const SOFT_BG  = "#F7F5F2";
const BORDER   = "#E7E1D8";
const INK      = "#1C1915";
const INK_SOFT = "#4A4540";
let authBootstrapInFlight = null;

/** Onglets autorisés pour le rôle client (Mon Projet, Synthèse, Messagerie). */
function isClientAllowedTab(activeTab) {
  if (activeTab === "messagerie" || activeTab === "synthese" || activeTab === "projets") return true;
  if (typeof activeTab === "string" && activeTab.startsWith("projets:")) return true;
  return false;
}

const DEFAULT_PROJECT_DATA = {
  companyName: "",
  companyLogo: "",
  logoSize: 120,
  deviseCode: "MAD",
  emetteur_nom: "",
  emetteur_representant: "",
  emetteur_designation: "",
  emetteur_adresse: "",
  emetteur_email: "",
  emetteur_telephone: "",
  emetteur_pays: "",
  emetteur_identifiants: "",
  nomClient: "",
  nomProjet: "",
  adresseProjet: "",
  montantGlobal: "",
  dateContrat: "",
  jalonsPaiement: "",
  validiteJours: "15",
  nationaliteClient: "",
  dateNaissanceClient: "",
  adresseClient: "",
  paysClient: "",
  villeClient: "",
  emailClient: "",
  pieceIdentiteNumero: "",
  pieceIdentiteDelivreLe: "",
  pieceIdentiteExpireLe: "",
  pieceIdentiteAutorite: "",
  localisationProjet: "",
  communeProjet: "",
  trancheProjet: "",
  lotProjet: "",
  superficieTerrain: "",
  superficieVilla: "",
  referenceFonciere: "",
  typeReferenceFonciere: "",
  perimetreMission: {
    analyseFaisabilite: true,
    verificationFonciere: true,
    coordinationArchitecte: true,
    selectionEntreprise: true,
    contratExecutionTravaux: true,
    ouvertureDossierProjet: true,
    transmissionDossierDemarrage: true,
    visitesChantier: true,
    comptesRendusVisite: true,
    suiviPlanning: true,
    validationJalons: true,
    gestionAvenants: true,
    interfaceUniqueEntreprise: true,
    reportingClient: true,
    receptionFonds: true,
    comptabiliteAnalytique: true,
    versementsEntreprise: true,
    etatFondsDisponibles: true,
    blocagePaiements: true,
    restitutionFonds: true,
    receptionContradictoire: true,
    procesVerbalReception: true,
    leveeReserves: true,
    versementSolde: true,
    clotureDocumentaire: true,
    remiseDossierCloture: true,
  },
  enveloppeA: "",
  enveloppeB: "",
  chargeStructure: "",
  decisionEmission: "",
  notesInternes: "",
  planningPrevisionnel: "",
  includeAnnexeA: true,
  includeAnnexeB: true,
  includeAnnexeC: true,
  includeClauseArbitrage: true,
  includeClauseBlocage: true,
  includeClauseSubstitution: true,
  contratSigne: false,
  premierVersementEncaisse: false,
  codeProjetCree: false,
  dossierDocumentaireOuvert: false,
  journalFinancierOuvert: false,
};

// â”€â”€ NAVIGATION â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

function PropositionContractuelleProjectPicker({ setActiveTab, cabinetId = null }) {
  const [projects, setProjects] = React.useState([]);
  const [loading] = React.useState(false);
  const [error] = React.useState(null);

  React.useEffect(() => {
    if (cabinetId == null) return;
    let cancelled = false;
    supabase
      .from("projects")
      .select("id, name")
      .eq("cabinet_id", cabinetId)
      .order("name")
      .then(({ data, error }) => {
        if (cancelled) return;
        if (!error && data) setProjects(data);
      });
    return () => { cancelled = true; };
  }, [cabinetId]);

  return (
    <main style={{ padding: 32, maxWidth: 560 }}>
      <h1 style={{ marginTop: 0, color: INK, fontSize: 22 }}>Proposition contractuelle</h1>
      <p style={{ color: INK_SOFT, marginBottom: 20, fontSize: 14 }}>
        Choisissez un projet pour ouvrir la proposition (PDF).
      </p>
      {loading && <p style={{ color: INK_SOFT }}>Chargement des projets…</p>}
      {error && <p style={{ color: "#b00020" }}>{error}</p>}
      {!loading && !error && (
        <select
          value=""
          onChange={(e) => {
            const id = e.target.value;
            if (id) setActiveTab(`proposition-contractuelle:${id}`);
          }}
          style={{
            width: "100%",
            padding: "12px 14px",
            fontSize: 15,
            borderRadius: 8,
            border: `1px solid ${BORDER}`,
            background: WHITE,
            color: INK,
          }}
        >
          <option value="">— Sélectionner un projet —</option>
          {projects.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name || p.id}
            </option>
          ))}
        </select>
      )}
    </main>
  );
}

const NAV_ADMIN = [
  {
    id: "entree",
    label: "PROSPECTS",
    items: [
      { id: "prequalification",       label: "Pr\u00e9qualification" },
      { id: "liste-prequalifications", label: "Liste des pr\u00e9qualifications" },
      { id: "formulaire-prospect",    label: "Formulaire Prospect" },
      { id: "preconsultations",    label: "Dossiers reçus" },
      { id: "fiche-client",        label: "Fiche Client / Identit\u00e9" },
      { id: "negociation",         label: "R\u00e9ponses Type / N\u00e9gociation" },
    ],
  },
  {
    id: "decision",
    label: "D\u00c9CISION",
    items: [
      { id: "analyse",             label: "Analyse Projet" },
      { id: "hypotheses-risques",  label: "Hypoth\u00e8ses & Risques", style: { display: "none" } },
      { id: "simulation-projet",   label: "Simulation Projet" },
      { id: "dossier-strategique", label: "Dossier Strat\u00e9gique", style: { display: "none" } },
      { id: "decision-finale",     label: "D\u00e9cision finale" },
    ],
  },
  {
    id: "contractualisation",
    label: "CONTRATS",
    items: [
      { id: "propositions",        label: "CRM Devis" },
      { id: "proposition",        label: "Cadre de proposition" },
      { id: "proposition-contractuelle", label: "Proposition contractuelle (PDF)" },
      { id: "contrat-client",     label: "Contrat Client" },
      { id: "annexes-clauses",    label: "Annexes & Clauses" },
      { id: "generateur-contrat", label: "G\u00e9n\u00e9rateur de Contrat" },
      { id: "contrat-ia",         label: "Contrat IA \u2728" },
      { id: "signature-projet",   label: "Signature Projet" },
    ],
  },
  {
    id: "projet",
    label: "PROJET",
    items: [
      { id: "projets",     label: "Projets" },
      { id: "jalons",      label: "Jalons" },
      { id: "pv-chantier", label: "PV de Chantier" },
      { id: "kanban",      label: "Kanban Chantier" },
      { id: "documents",   label: "Documents" },
    ],
  },
  {
    id: "missions",
    label: "MISSIONS",
    items: [
      { id: "mission-archi-interieure", label: "Mission Archi Intérieure" },
      { id: "mission-opc", label: "Mission OPC" },
      { id: "mission-mandataire", label: "Mission Mandataire" },
      { id: "mission-amo", label: "Mission AMO" },
      { id: "mission-conducteur-travaux", label: "Mission Conducteur de Travaux" },
    ],
  },
  {
    id: "promotion",
    label: "PROMOTION",
    items: [
      { id: "dashboard-promotion", label: "Dashboard" },
      { id: "suivi-ventes", label: "Suivi des Ventes" },
      { id: "contrat-acquereur", label: "Contrat VEFA" },
      { id: "appels-paiement", label: "Appels à Paiement" },
      { id: "simulation-villas", label: "Simulation Multi-Projets" },
      { id: "simulation-scenarios", label: "Simulation Sc\u00e9narios" },
    ],
  },
  {
    id: "finance",
    label: "FINANCE",
    items: [
      { id: "finance",             label: "Vue G\u00e9n\u00e9rale" },
      { id: "echeancier",          label: "\u00c9ch\u00e9ancier" },
      { id: "dashboard-financier", label: "Dashboard Financier" },
    ],
  },
  {
    id: "reporting",
    label: "REPORTING",
    items: [
      { id: "dashboard",        label: "Tableau de Bord" },
      { id: "alertes",          label: "Alertes" },
      { id: "synthese",         label: "Synth\u00e8se Projet" },
      { id: "rapport",          label: "Rapport Investisseur" },
    ],
  },
  {
    id: "outils",
    label: "OUTILS",
    items: [
      { id: "__outils_metier__", label: "OUTILS MÉTIER", nonClickable: true, style: { background: "transparent", color: INK, fontSize: 10, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase", marginTop: 4, marginBottom: 4, padding: "4px 2px" } },
      { id: "ffe",                  label: "🛋 Sélection FF&E" },
      { id: "estimator",            label: "📐 Métré & Estimatif" },
      { id: "devis-intelligent",    label: "📋 Devis Intelligent" },
      { id: "timelapse-ia",         label: "🎬 Time-Lapse IA" },
      { id: "process",              label: "Process YOMA" },
      { id: "constructeurs",        label: "Constructeurs" },
      { id: "gantt",                label: "Planning / Gantt" },
      { id: "referentiel-yoma",     label: "Référentiel YOMA" },
      { id: "__outils_sep__",       label: "", nonClickable: true, style: { height: 1, background: "rgba(0,0,0,0.2)", margin: "8px 4px 10px" } },
      { id: "__outils_admin__",     label: "ADMINISTRATION", nonClickable: true, style: { background: "transparent", color: INK, fontSize: 10, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 4, padding: "4px 2px" } },
      { id: "branding",             label: "Branding / Logo" },
      { id: "utilisateurs",         label: "Gestion des acc\u00e8s" },
      { id: "upgrade",              label: "\u2b50 Forfaits & Upgrade" },
      { id: "messagerie",           label: "\ud83d\udcac Messagerie" },
    ],
  },
];

const NAV_CHEF_CHANTIER = [
  {
    id: "projet",
    label: "CHANTIER",
    items: [
      { id: "projets",   label: "Mes Projets" },
      { id: "jalons",    label: "Planning" },
      { id: "process",   label: "Process Op\u00e9rationnel" },
      { id: "documents", label: "Documents" },
    ],
  },
];

/**
 * OPC mandaté (opc_type mandate ou non défini) : menus réduits.
 * PROJET : assignés via opc_projets ; REPORTING : alertes + synthèse ; OUTILS : sans upgrade/simulations.
 */
const NAV_OPC_MANDATE = [
  {
    id: "projet",
    label: "PROJET",
    items: [
      { id: "projets",     label: "Projets" },
      { id: "jalons",      label: "Jalons" },
      { id: "pv-chantier", label: "PV de Chantier" },
      { id: "kanban",      label: "Kanban Chantier" },
      { id: "documents",   label: "Documents" },
    ],
  },
  {
    id: "missions",
    label: "MISSIONS",
    items: [
      { id: "mission-archi-interieure", label: "Mission Archi Int\u00e9rieure" },
      { id: "mission-opc", label: "Mission OPC" },
      { id: "mission-mandataire", label: "Mission Mandataire" },
      { id: "mission-amo", label: "Mission AMO" },
      { id: "mission-conducteur-travaux", label: "Mission Conducteur de Travaux" },
    ],
  },
  {
    id: "reporting",
    label: "REPORTING",
    items: [
      { id: "alertes",  label: "Alertes" },
      { id: "synthese", label: "Synth\u00e8se Projet" },
    ],
  },
  {
    id: "outils",
    label: "OUTILS",
    items: [
      { id: "process",       label: "Process YOMA" },
      { id: "constructeurs", label: "Constructeurs" },
      { id: "gantt",         label: "Planning / Gantt" },
      { id: "messagerie",    label: "\ud83d\udcac Messagerie" },
    ],
  },
];

const NAV_CLIENT = [
  {
    id: "monprojet",
    label: "MON PROJET",
    items: [
      { id: "projets",    label: "Mon Projet" },
      { id: "synthese",   label: "Synth\u00e8se" },
      { id: "messagerie", label: "\ud83d\udcac Messagerie" },
    ],
  },
];

const NAV_ENTREPRISE = [
  {
    id: "chantier",
    label: "CHANTIER",
    items: [
      { id: "projets",             label: "Mes Projets" },
      { id: "entreprise-chantier", label: "Avancement & R\u00e9ponses" },
      { id: "documents",           label: "Documents" },
      { id: "messagerie",          label: "\ud83d\udcac Messagerie" },
    ],
  },
];

/**
 * @param {object} [profile] — utilisé pour OPC : indépendant → menu admin ; sinon menu mandaté restreint.
 */
function getNav(role, profile) {
  switch (role) {
    case "admin":
    case "administrateur":
      return NAV_ADMIN;
    case "chef_chantier":
      return NAV_CHEF_CHANTIER;
    case "opc":
      return profile?.opc_type === "independant" ? NAV_ADMIN : NAV_OPC_MANDATE;
    case "client":
      return NAV_CLIENT;
    case "entreprise":
      return NAV_ENTREPRISE;
    default:
      return NAV_CLIENT;
  }
}

function getDefaultTab(role, profile) {
  switch (role) {
    case "admin":
    case "administrateur":
      return "dashboard";
    case "chef_chantier":
      return "projets";
    case "opc":
      return profile?.opc_type === "independant" ? "dashboard" : "projets";
    case "client":
      return "projets";
    case "entreprise":
      return "entreprise-chantier";
    default:
      return "projets";
  }
}

/** Clé de page normalisée (comme renderPage) pour contrôle d’accès OPC mandaté. */
function getOpcMandatePageKey(activeTab) {
  if (activeTab === "projets" || (typeof activeTab === "string" && activeTab.startsWith("projets:"))) return "projets";
  if (activeTab === "proposition-contractuelle" || (typeof activeTab === "string" && activeTab.startsWith("proposition-contractuelle:"))) {
    return "proposition-contractuelle";
  }
  return activeTab;
}

const OPC_MANDATE_ALLOWED_KEYS = new Set([
  "projets",
  "jalons",
  "pv-chantier",
  "kanban",
  "documents",
  "mission-archi-interieure",
  "mission-opc",
  "mission-mandataire",
  "mission-amo",
  "mission-conducteur-travaux",
  "alertes",
  "synthese",
  "process",
  "constructeurs",
  "gantt",
  "messagerie",
]);

/** Accès direct (URL / état) : uniquement ces pages pour OPC mandaté. */
function isOpcMandateAllowedTab(activeTab) {
  const key = getOpcMandatePageKey(activeTab);
  return OPC_MANDATE_ALLOWED_KEYS.has(key);
}

/** Fusionne `profiles` et `user_profiles` (priorité aux colonnes de user_profiles). */
async function loadMergedProfile(userId, authUser) {
  let { data: up } = await supabase
    .from("user_profiles")
    .select("*")
    .eq("id", userId)
    .maybeSingle();

  if (!up) {
    await supabase.from("user_profiles").upsert(
      { id: userId, role: "administrateur" },
      { onConflict: "id" }
    );
    const { data: upAgain } = await supabase
      .from("user_profiles")
      .select("*")
      .eq("id", userId)
      .maybeSingle();
    up = upAgain;
  }

  const base = authUser
    ? { id: userId, email: authUser.email ?? null }
    : null;

  if (!base) return null;

  const merged = { ...base, ...(up || {}) };
  console.log("ROLE:", merged?.role);
  return merged;
}

async function getCabinetId(userId) {
  const { data: cabinet } = await supabase
    .from("cabinets")
    .select("id")
    .eq("admin_id", userId)
    .maybeSingle();

  if (cabinet?.id) {
    try { localStorage.setItem("yoma_cabinet_id", cabinet.id); } catch (_) {}
    return cabinet.id;
  }

  const { data: newCabinet, error: createCabinetError } = await supabase
    .from("cabinets")
    .insert({ admin_id: userId })
    .select("id")
    .single();

  if (createCabinetError) throw createCabinetError;
  const cabinetId = newCabinet?.id || null;
  if (cabinetId) {
    try { localStorage.setItem("yoma_cabinet_id", cabinetId); } catch (_) {}
  }
  return cabinetId;
}

function getRoleLabel(role) {
  switch (role) {
    case "admin":
    case "administrateur": return "Administrateur";
    case "chef_chantier": return "Chef de Chantier";
    case "opc":           return "OPC";
    case "client":        return "Client";
    case "entreprise":    return "Entreprise";
    default:              return role;
  }
}


// â”€â”€ App â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export default function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const isCheckoutSuccess = urlParams.get("checkout") === "success";
  const isSignup =
    urlParams.get("signup") === "true" || isCheckoutSuccess;
  const isSignupPath =
    window.location.pathname === "/inscription" ||
    window.location.pathname === "/signup";

  const [profile,     setProfile]     = useState(null);
  const [userRole,    setUserRole]   = useState(() => {
    try {
      const savedRole = localStorage.getItem("yoma_role");
      return savedRole || null;
    } catch {
      return null;
    }
  });
  const [authReady,   setAuthReady]   = useState(false);
  const [activeTab,   setActiveTab]   = useState("dashboard");
  const [openSection, setOpenSection] = useState("");
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [opcProjectIds, setOpcProjectIds] = useState([]);
  const [cabinetId, setCabinetId] = useState(null);
  const [signupFirstName, setSignupFirstName] = useState("");
  const [signupLastName, setSignupLastName] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [signupPasswordConfirm, setSignupPasswordConfirm] = useState("");
  const [signupLoading, setSignupLoading] = useState(false);
  const [signupError, setSignupError] = useState("");
  const [signupSuccess, setSignupSuccess] = useState("");
  const [cabinet, setCabinet] = useState(null);

  // ── Détection plateforme + offline devis ──────────────────────────────────
  const { isMobile } = useDevice();
  const { isOnline, unsyncedCount } = useOfflineDevis(cabinetId);

  const [projectData, setProjectData] = useState(DEFAULT_PROJECT_DATA);

  // Chargement du branding depuis Supabase quand le cabinetId change
  useEffect(() => {
    if (!cabinetId) {
      setProjectData(DEFAULT_PROJECT_DATA);
      return;
    }
    async function loadBranding() {
      try {
        const { data } = await supabase
          .from("cabinets")
          .select("branding")
          .eq("id", cabinetId)
          .maybeSingle();
        if (data?.branding && Object.keys(data.branding).length > 0) {
          setProjectData({
            ...DEFAULT_PROJECT_DATA,
            ...data.branding,
            perimetreMission: {
              ...DEFAULT_PROJECT_DATA.perimetreMission,
              ...(data.branding.perimetreMission || {}),
            },
          });
        } else {
          setProjectData(DEFAULT_PROJECT_DATA);
        }
      } catch (e) {
        setProjectData(DEFAULT_PROJECT_DATA);
      }
    }
    loadBranding();
  }, [cabinetId]);

  useEffect(() => {
    if (!profile?.role) return;
    try {
      localStorage.setItem("yoma_role", profile.role);
    } catch (_) {}
    setUserRole(profile.role);
  }, [profile]);

  // Après un paiement Stripe réussi, on force un refresh de session
  // pour que usePlan recharge le plan mis à jour par le webhook.
  useEffect(() => {
    if (!isCheckoutSuccess) return;
    const timer = setTimeout(async () => {
      try {
        await supabase.auth.refreshSession();
      } catch (_) {}
      // Nettoyer le paramètre d'URL sans recharger la page
      const url = new URL(window.location.href);
      url.searchParams.delete("checkout");
      window.history.replaceState({}, "", url.toString());
    }, 2000); // 2 s pour laisser le webhook le temps de s'exécuter
    return () => clearTimeout(timer);
  }, [isCheckoutSuccess]);

  useEffect(() => {
    let cancelled = false;

    async function bootstrapAuth() {
      if (!authBootstrapInFlight) {
        authBootstrapInFlight = supabase.auth
          .getSession()
          .finally(() => {
            authBootstrapInFlight = null;
          });
      }

      const { data: { session } } = await authBootstrapInFlight;
      if (cancelled) return;

      if (session) {
        const merged = await loadMergedProfile(session.user.id, session.user);
        let nextCabinetId = null;
        try {
          nextCabinetId = localStorage.getItem("yoma_cabinet_id");
        } catch (_) {}
        if (!nextCabinetId) {
          nextCabinetId = await getCabinetId(session.user.id);
        }
        if (cancelled) return;
        setCabinetId(nextCabinetId);
        if (merged) {
          setProfile(merged);
          if (merged.role) {
            try {
              localStorage.setItem("yoma_role", merged.role);
            } catch (_) {}
            setUserRole(merged.role);
          }
          setActiveTab(getDefaultTab(merged.role, merged));
          const nav = getNav(merged.role, merged);
          setOpenSection(nav[0]?.id || "");
        }
      }
      if (!cancelled) setAuthReady(true);
    }

    bootstrapAuth();

    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      if ((event === "SIGNED_OUT" || !session) && !cancelled) {
        setProfile(null);
        setCabinetId(null);
        setProjectData(DEFAULT_PROJECT_DATA);
        try { localStorage.removeItem("yoma_cabinet_id"); } catch (_) {}
        try { localStorage.removeItem("yoma_role"); } catch (_) {}
        try { localStorage.removeItem("yoma_projectData"); } catch (_) {}
        setUserRole(null);
        return;
      }
    });

    return () => {
      cancelled = true;
      listener.subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!profile) return;
    try {
      const done = localStorage.getItem("yoma_onboarding_done");
      const userRole = profile.role;
      if (!done && (userRole === "administrateur" || userRole === "admin")) {
        setShowOnboarding(true);
      } else {
        setShowOnboarding(false);
      }
    } catch {
      setShowOnboarding(false);
    }
  }, [profile]);

  useEffect(() => {
    if (!profile) return;
    const nav = getNav(profile.role, profile);
    const found = nav.find((s) =>
      s.items.some((i) => {
        if (i.id === activeTab) return true;
        if (typeof activeTab === "string" && activeTab.startsWith(`${i.id}:`)) return true;
        return false;
      })
    );
    if (found) setOpenSection(found.id);
  }, [activeTab, profile]);

  useLayoutEffect(() => {
    if (!profile || profile.role !== "client") return;
    if (!isClientAllowedTab(activeTab)) {
      setActiveTab("projets");
    }
  }, [profile, activeTab]);

  useLayoutEffect(() => {
    if (!profile || profile.role !== "opc") return;
    if (profile.opc_type === "independant") return;
    if (!isOpcMandateAllowedTab(activeTab)) {
      setActiveTab("projets");
    }
  }, [profile, activeTab]);

  const isOPCMandate = profile?.role === "opc" && profile?.opc_type === "mandate";
  const opcBlockedKeys = new Set([
    // DECISION
    "analyse",
    "hypotheses-risques",
    "simulation-projet",
    "dossier-strategique",
    "decision-finale",
    // CONTRACTUALISATION
    "proposition",
    "propositions",
    "proposition-contractuelle",
    "proposition-contractuelle-pick",
    "contrat-client",
    "annexes-clauses",
    "generateur-contrat",
    "contrat-ia",
    "signature-projet",
    // FINANCE
    "finance",
    "echeancier",
    "dashboard-financier",
    // PROMOTION
    "dashboard-promotion",
    "suivi-ventes",
    "contrat-acquereur",
    "appels-paiement",
    "simulation-villas",
    "simulation-scenarios",
    // Spécifiques demandés
    "referentiel-yoma",
    "upgrade",
  ]);

  useLayoutEffect(() => {
    if (!isOPCMandate) return;
    const key = getOpcMandatePageKey(activeTab);
    if (opcBlockedKeys.has(key)) {
      setActiveTab("projets");
    }
  }, [isOPCMandate, activeTab]);

  useEffect(() => {
    let cancelled = false;
    async function loadOpcProjectIds() {
      if (!isOPCMandate || !profile?.id) {
        if (!cancelled) setOpcProjectIds([]);
        return;
      }
      const { data, error } = await supabase
        .from("opc_projets")
        .select("project_id")
        .eq("opc_id", profile.id);
      if (cancelled) return;
      if (error) {
        setOpcProjectIds([]);
        return;
      }
      const ids = (data || []).map((r) => r.project_id).filter(Boolean);
      setOpcProjectIds(ids);
    }
    loadOpcProjectIds();
    return () => { cancelled = true; };
  }, [isOPCMandate, profile?.id]);

  async function handleLogout() {
    await supabase.auth.signOut();
    setProfile(null);
    setCabinetId(null);
    setProjectData(DEFAULT_PROJECT_DATA);
    try { localStorage.removeItem("yoma_cabinet_id"); } catch (_) {}
    try { localStorage.removeItem("yoma_role"); } catch (_) {}
    try { localStorage.removeItem("yoma_projectData"); } catch (_) {}
    setUserRole(null);
  }

  async function handleLogin(prof) {
    const merged = await loadMergedProfile(prof.id, prof);
    const p = merged || prof;
    const nextCabinetId = await getCabinetId(prof.id);
    setCabinetId(nextCabinetId);
    setProfile(p);
    if (p?.role) {
      try {
        localStorage.setItem("yoma_role", p.role);
      } catch (_) {}
      setUserRole(p.role);
    }
    setActiveTab(getDefaultTab(p.role, p));
    const nav = getNav(p.role, p);
    setOpenSection(nav[0]?.id || "");
  }

  async function handleCheckoutSignup(e) {
    e?.preventDefault?.();
    setSignupError("");
    setSignupSuccess("");
    if (!signupEmail.trim() || !signupPassword || !signupPasswordConfirm) {
      setSignupError("Veuillez remplir tous les champs.");
      return;
    }
    if (!signupFirstName.trim() || !signupLastName.trim()) {
      setSignupError("Veuillez renseigner le prénom et le nom.");
      return;
    }
    if (signupPassword !== signupPasswordConfirm) {
      setSignupError("Les mots de passe ne correspondent pas.");
      return;
    }
    if (signupPassword.length < 8) {
      setSignupError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }

    setSignupLoading(true);
    try {
      const { data, error: signUpError } = await supabase.auth.signUp({
        email: signupEmail.trim(),
        password: signupPassword,
        options: {
          data: {
            first_name: signupFirstName.trim(),
            last_name: signupLastName.trim(),
            full_name: `${signupFirstName.trim()} ${signupLastName.trim()}`.trim(),
          },
          emailRedirectTo: "https://app.yoma.design",
        },
      });
      if (signUpError) throw signUpError;
      if (data?.user?.id) {
        const userId = data.user.id

        // Créer user_profiles
        await supabase.from('user_profiles').upsert({
          id: userId,
          role: 'administrateur',
          opc_type: null
        }, { onConflict: 'id' })

        // Créer cabinet
        const expiresAt = new Date(
          Date.now() + 10 * 24 * 60 * 60 * 1000
        ).toISOString()

        await supabase.from('cabinets').upsert({
          admin_id: userId,
          expires_at: expiresAt
        }, { onConflict: 'admin_id' })

        // Connexion immédiate puis rechargement
        await supabase.auth.signInWithPassword({
          email: signupEmail.trim(),
          password: signupPassword,
        });
        window.location.reload();
        return;
      }
      setSignupSuccess("Compte créé ! Vérifiez votre email pour vous connecter.");
    } catch (err) {
      setSignupError(err?.message || "Inscription impossible.");
    } finally {
      setSignupLoading(false);
    }
  }

  function toggleSection(id) {
    setOpenSection((prev) => (prev === id ? "" : id));
  }

  if (!authReady) {
    return (
      <div style={{ minHeight: "100vh", background: TAUPE, display: "flex", alignItems: "center",
        justifyContent: "center", fontFamily: "system-ui", fontSize: 13, color: WHITE,
        letterSpacing: "0.15em", textTransform: "uppercase" }}>
        YOMA
      </div>
    );
  }

  // Route publique pré-consultation (accessible sans authentification)
  const hash = window.location.hash || "";
  const preconsultationMatch = hash.match(/\/preconsultation\/([^?#]+)/);
  if (preconsultationMatch) {
    return <PreConsultationPublic token={preconsultationMatch[1]} />;
  }

  if ((isSignup || isSignupPath) && !profile) {
    return (
      <div style={{ minHeight: "100vh", background: "#F8F4EE", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
        <div style={{ width: "100%", maxWidth: 580, background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 16, boxShadow: "0 14px 38px rgba(0,0,0,0.1)", padding: "30px 30px 24px" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 6 }}>
            <svg width="120" height="120" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
              <g fill="#A89278" fontFamily="Didot, 'Bodoni MT', 'Times New Roman', serif" fontWeight="400">
                <text x="160" y="190" fontSize="110" letterSpacing="10">Y</text>
                <text x="255" y="190" fontSize="110" letterSpacing="10">O</text>
                <line x1="125" y1="230" x2="375" y2="230" stroke="#A89278" strokeWidth="2" />
                <text x="155" y="335" fontSize="110" letterSpacing="10">M</text>
                <text x="285" y="335" fontSize="110" letterSpacing="10">A</text>
              </g>
            </svg>
          </div>
          <div style={{ textAlign: "center", marginBottom: 20, display: "grid", gap: 8 }}>
            <div style={{ display: "inline-block", margin: "0 auto", padding: "6px 12px", borderRadius: 999, background: "rgba(26,122,68,0.14)", border: "1px solid rgba(26,122,68,0.35)", color: "#1A7A44", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase" }}>
              Essai gratuit
            </div>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, color: INK, marginBottom: 2 }}>Créez votre compte YOMA</div>
            <div style={{ color: INK_SOFT, fontSize: 15 }}>10 jours gratuits — sans carte bancaire</div>
          </div>

          <form onSubmit={handleCheckoutSignup} style={{ display: "grid", gap: 12 }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <input
                type="text"
                placeholder="Prénom"
                value={signupFirstName}
                onChange={(e) => setSignupFirstName(e.target.value)}
                style={{ width: "100%", padding: "12px 14px", borderRadius: 8, border: `1px solid ${BORDER}`, fontSize: 14, background: "#FBF9F6" }}
              />
              <input
                type="text"
                placeholder="Nom"
                value={signupLastName}
                onChange={(e) => setSignupLastName(e.target.value)}
                style={{ width: "100%", padding: "12px 14px", borderRadius: 8, border: `1px solid ${BORDER}`, fontSize: 14, background: "#FBF9F6" }}
              />
            </div>
            <input
              type="email"
              placeholder="Email"
              value={signupEmail}
              onChange={(e) => setSignupEmail(e.target.value)}
              style={{ width: "100%", padding: "12px 14px", borderRadius: 8, border: `1px solid ${BORDER}`, fontSize: 14, background: "#FBF9F6" }}
            />
            <input
              type="password"
              placeholder="Mot de passe (min 8 caractères)"
              value={signupPassword}
              onChange={(e) => setSignupPassword(e.target.value)}
              style={{ width: "100%", padding: "12px 14px", borderRadius: 8, border: `1px solid ${BORDER}`, fontSize: 14, background: "#FBF9F6" }}
            />
            <input
              type="password"
              placeholder="Confirmer mot de passe"
              value={signupPasswordConfirm}
              onChange={(e) => setSignupPasswordConfirm(e.target.value)}
              style={{ width: "100%", padding: "12px 14px", borderRadius: 8, border: `1px solid ${BORDER}`, fontSize: 14, background: "#FBF9F6" }}
            />

            {signupError && <div style={{ color: "#B85C3A", fontSize: 13 }}>{signupError}</div>}
            {signupSuccess && <div style={{ color: "#1A7A44", fontSize: 13, fontWeight: 600 }}>{signupSuccess}</div>}

            <button
              type="submit"
              disabled={signupLoading}
              style={{ marginTop: 4, border: "none", borderRadius: 10, padding: "12px 16px", background: GOLD, color: WHITE, fontWeight: 700, cursor: signupLoading ? "not-allowed" : "pointer", opacity: signupLoading ? 0.7 : 1 }}
            >
              {signupLoading ? "Création..." : "Créer mon compte"}
            </button>

            <button
              type="button"
              onClick={() => {
                window.location.href = "https://app.yoma.design";
              }}
              style={{ marginTop: 2, border: "none", background: "transparent", color: INK_SOFT, textDecoration: "underline", fontSize: 13, cursor: "pointer" }}
            >
              Déjà un compte ? Se connecter
            </button>
          </form>
        </div>
      </div>
    );
  }

  if (!profile) return <LoginPage onLogin={handleLogin} />;

  if (profile.role === "entreprise") {
    return (
      <EntrepriseDashboardPage
        cabinetId={cabinetId}
        entrepriseId={profile.id}
        entrepriseData={profile}
        profile={profile}
        onLogout={handleLogout}
      />
    );
  }

  if (profile.role === "client") {
    return (
      <ClientDashboardPage
        cabinetId={cabinetId}
        profile={profile}
        clientEmail={profile.email ?? null}
        userId={profile.id}
        onLogout={() => supabase.auth.signOut()}
      />
    );
  }

  const nav = getNav(profile.role, profile);
  const currentUser = profile;

  // Navigation mobile — mappe les IDs MobileNav vers les IDs App
  function handleMobileTabChange(tabId) {
    if (tabId === "__settings") { setActiveTab("upgrade"); return; }
    if (tabId === "visualisation-temporelle-ai") { setActiveTab("timelapse-ia"); return; }
    setActiveTab(tabId);
  }
  const opcMandateOrUnset =
    profile.role === "opc" && profile.opc_type !== "independant";
  const opcNeedsTypeConfig = profile.role === "opc" && (profile.opc_type === null || profile.opc_type === undefined);
  const TAB_TITLES = {};
  nav.forEach((s) => s.items.forEach((item) => { TAB_TITLES[item.id] = item.label; }));
  TAB_TITLES["proposition-contractuelle"] = "Proposition contractuelle";
  TAB_TITLES["propositions"] = "CRM Devis";

  function renderPage() {
    const shared = { projectData, setProjectData, cabinetId };
    const pageKey = activeTab === "projets" || (typeof activeTab === "string" && activeTab.startsWith("projets:"))
      ? "projets"
      : activeTab === "proposition-contractuelle"
      ? "proposition-contractuelle-pick"
      : (typeof activeTab === "string" && activeTab.startsWith("proposition-contractuelle:"))
      ? "proposition-contractuelle"
      : activeTab;
    const projetsOpenId = typeof activeTab === "string" && activeTab.startsWith("projets:")
      ? activeTab.replace(/^projets:/, "")
      : null;
    const propositionProjectId = typeof activeTab === "string" && activeTab.startsWith("proposition-contractuelle:")
      ? activeTab.replace(/^proposition-contractuelle:/, "")
      : null;

    switch (pageKey) {

      // â”€â”€ OUTILS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "utilisateurs":
      case "gestion-acces":
        return (
          <PlanGate requiredPlan="expert" featureName="Gestion des acc\u00e8s" cabinet={cabinet}>
            <UsersManagementPage cabinetId={cabinetId} />
          </PlanGate>
        );
      case "ffe":
        return <FFEPage cabinetId={cabinetId} />;
      case "estimator":
        return <EstimatorPage cabinetId={cabinetId} />;
      case "devis-intelligent":
        return <DevisIntelligentPage cabinetId={cabinetId} />;
      case "timelapse-ia":
        return <VisualisationTemporelleAIPage cabinetId={cabinetId} />;
      case "branding":
        return <BrandingSettingsPage {...shared} />;
      case "upgrade":
        return <UpgradePage cabinetId={cabinetId} />;
      case "gantt":
        return <GanttPage cabinetId={cabinetId} isOPCMandate={isOPCMandate} />;
      case "messagerie":
        return (
          <MessagerPage
            profile={profile}
            restrictedToAdmin={profile.role === "client"}
            isOPCMandate={isOPCMandate}
          />
        );
      case "process":
        return <ProcessYomaPage cabinetId={cabinetId} />;
      case "constructeurs":
        return <ConstructorsPage cabinetId={cabinetId} />;

      // â”€â”€ ENTREE â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "prequalification":
        return <AcquisitionClientPage cabinetId={cabinetId} />;
      case "liste-prequalifications":
        return <ListePrequalificationsPage cabinetId={cabinetId} setActiveTab={setActiveTab} />;
      case "formulaire-prospect":
        return <FormulaireProspectPage cabinetId={cabinetId} setActiveTab={setActiveTab} />;
      case "preconsultations":
        return <PreConsultationsPage cabinetId={cabinetId} setActiveTab={setActiveTab} />;
      case "preconsultation": {
        const tokenFromHash = (window.location.hash || "").match(/\/preconsultation\/([^?#]+)/)?.[1];
        const tokenFromTab = typeof activeTab === "string" && activeTab.includes(":") ? activeTab.split(":")[1] : null;
        const token = tokenFromHash || tokenFromTab || "";
        return <PreConsultationPublic token={token} />;
      }
      case "fiche-client":
        return <ClientIdentityPage {...shared} />;
      case "negociation":
        return <NegotiationResponsesPage cabinetId={cabinetId} />;

      // â”€â”€ DECISION â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "analyse":
        return <DecisionPage cabinetId={cabinetId} setActiveTab={setActiveTab} />;
      case "hypotheses-risques":
        return <HypothesesRisquesPage cabinetId={cabinetId} />;
      case "simulation-projet":
        return <ProjectSimulationPage cabinetId={cabinetId} />;
      case "dossier-strategique":
        return <StrategicDossierPage cabinetId={cabinetId} setActiveTab={setActiveTab} />;
      case "decision-finale":
        return <DecisionFinalePage cabinetId={cabinetId} />;

      // â”€â”€ CONTRACTUALISATION â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "proposition":
        return <ProposalPage {...shared} />;
      case "contrat-client":
        return (
          <PlanGate requiredPlan="starter" featureName="Contrat Client" cabinet={cabinet}>
            <ContractClientPage {...shared} />
          </PlanGate>
        );
      case "annexes-clauses":
        return (
          <PlanGate requiredPlan="starter" featureName="Annexes & Clauses" cabinet={cabinet}>
            <AnnexesClausesPage {...shared} />
          </PlanGate>
        );
      case "generateur-contrat":
        return (
          <PlanGate requiredPlan="expert" featureName="G\u00e9n\u00e9rateur de contrat" cabinet={cabinet}>
            <ContractGeneratorPage {...shared} />
          </PlanGate>
        );
      case "contrat-ia":
        return (
          <PlanGate requiredPlan="pro" featureName="Contrat IA" cabinet={cabinet}>
            <ContractAIGeneratorPage cabinetId={cabinetId} />
          </PlanGate>
        );
      case "signature-projet":
        return (
          <PlanGate requiredPlan="starter" featureName="Signature Projet" cabinet={cabinet}>
            <SignatureProjectPage {...shared} setActiveTab={setActiveTab} />
          </PlanGate>
        );

      // â”€â”€ PROJET â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "projets":
        return (
          <ProjectsPage
            openProjectId={projetsOpenId}
            setActiveTab={setActiveTab}
            clientEmail={profile.role === "client" ? profile.email || null : null}
            opcUserId={opcMandateOrUnset ? profile.id : null}
            isOPCMandate={isOPCMandate}
            allowedProjectIds={isOPCMandate ? opcProjectIds : undefined}
          />
        );
      case "propositions":
        return <PropositionsPage cabinetId={cabinetId} setActiveTab={setActiveTab} />;
      case "proposition-contractuelle-pick":
        return <PropositionContractuelleProjectPicker cabinetId={cabinetId} setActiveTab={setActiveTab} />;
      case "proposition-contractuelle":
        return <PropositionContractuellePage cabinetId={cabinetId} projectId={propositionProjectId} setActiveTab={setActiveTab} projectData={projectData} />;
      case "jalons":
        return (
          <PlanGate requiredPlan="pro" featureName="Jalons & Planning" cabinet={cabinet}>
            <MilestonesPage
              cabinetId={cabinetId}
              isOPCMandate={isOPCMandate}
              allowedProjectIds={isOPCMandate ? opcProjectIds : undefined}
            />
          </PlanGate>
        );
      case "pv-chantier":
        return (
          <PVChantierPage
            cabinetId={cabinetId}
            profile={profile}
            isOPCMandate={isOPCMandate}
            allowedProjectIds={isOPCMandate ? opcProjectIds : undefined}
          />
        );
      case "kanban":
        return (
          <KanbanPage
            cabinetId={cabinetId}
            profile={profile}
            isOPCMandate={isOPCMandate}
            allowedProjectIds={isOPCMandate ? opcProjectIds : undefined}
          />
        );
      case "documents":
        return (
          <DocumentsPage
            cabinetId={cabinetId}
            isOPCMandate={isOPCMandate}
            allowedProjectIds={isOPCMandate ? opcProjectIds : undefined}
          />
        );

      case "projet-archi-interieure":
      case "mission-archi-interieure":
        return <ProjetArchitectureInterieure cabinetId={cabinetId} />;

      case "mission-opc":
        return <MissionOPC cabinetId={cabinetId} isOPCMandate={isOPCMandate} />;

      case "mission-mandataire":
        return <MissionMandataire cabinetId={cabinetId} />;

      case "mission-amo":
        return <MissionAMO cabinetId={cabinetId} />;

      case "mission-conducteur-travaux":
        return <MissionConducteurTravaux cabinetId={cabinetId} />;

      // â”€â”€ PROMOTION â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "dashboard-promotion":
        return <DashboardPromotionPage cabinetId={cabinetId} />;
      case "suivi-ventes":
        return <SuiviVentesPage cabinetId={cabinetId} />;
      case "contrat-acquereur":
        return <ContratAcquereurPage cabinetId={cabinetId} />;
      case "appels-paiement":
        return <AppelsPaiementPage cabinetId={cabinetId} />;
      case "simulation-villas":
      case "simulation-multi":
        return (
          <PlanGate requiredPlan="starter" featureName="Simulation Multi-Projets" cabinet={cabinet}>
            <MultiVillaSimulationPage cabinetId={cabinetId} />
          </PlanGate>
        );
      case "simulation-scenarios":
        return (
          <PlanGate requiredPlan="starter" featureName="Simulation multi-sc\u00e9narios" cabinet={cabinet}>
            <ScenarioSimulationPage cabinetId={cabinetId} />
          </PlanGate>
        );

      // â”€â”€ FINANCE â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "finance":
      case "vue-generale":
        return (
          <PlanGate requiredPlan="pro" featureName="Suivi financier" cabinet={cabinet}>
            <FinancePage cabinetId={cabinetId} />
          </PlanGate>
        );
      case "echeancier":
        return (
          <PlanGate requiredPlan="pro" featureName="\u00c9ch\u00e9ancier" cabinet={cabinet}>
            <PaymentSchedulePage cabinetId={cabinetId} />
          </PlanGate>
        );
      case "dashboard-financier":
        return (
          <PlanGate requiredPlan="pro" featureName="Dashboard financier" cabinet={cabinet}>
            <ProjectFinancialDashboardPage cabinetId={cabinetId} />
          </PlanGate>
        );

      // â”€â”€ REPORTING â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "dashboard":
        return <DashboardPage cabinetId={cabinetId} setActiveTab={setActiveTab} />;
      case "alertes":
        return (
          <AlertsPage
            cabinetId={cabinetId}
            isOPCMandate={isOPCMandate}
            allowedProjectIds={isOPCMandate ? opcProjectIds : undefined}
          />
        );
      case "synthese":
        return (
          <ProjectSummaryPage
            cabinetId={cabinetId}
            clientEmail={profile.role === "client" ? profile.email || null : null}
            isOPCMandate={isOPCMandate}
            allowedProjectIds={isOPCMandate ? opcProjectIds : undefined}
          />
        );
      case "rapport":
      case "rapport-investisseur":
        return (
          <PlanGate requiredPlan="pro" featureName="Rapport Investisseur" cabinet={cabinet}>
            <InvestorReportPage cabinetId={cabinetId} />
          </PlanGate>
        );
      case "referentiel-yoma":
        return <YomaKnowledgePage cabinetId={cabinetId} activeTab={activeTab} setActiveTab={setActiveTab} />;

      // â”€â”€ ROLES SPECIAUX â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "client-dashboard":
        return (
          <ClientDashboardPage
            profile={profile}
            clientEmail={profile.email ?? null}
            userId={profile.id}
          />
        );
      case "entreprise-chantier":
        return <EntreprisePage cabinetId={cabinetId} profile={profile} />;

      // â”€â”€ LEGACY â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
      case "clients":
        return <ClientsPage cabinetId={cabinetId} />;

      default:
        return null;
    }
  }

  const currentPageKey = activeTab === "projets" || (typeof activeTab === "string" && activeTab.startsWith("projets:"))
    ? "projets"
    : (typeof activeTab === "string" && (activeTab === "proposition-contractuelle" || activeTab.startsWith("proposition-contractuelle:")))
    ? "proposition-contractuelle"
    : activeTab;

  return (
    <div style={{ display: "flex", fontFamily: "system-ui, -apple-system, sans-serif" }}>

      {/* â”€â”€ SIDEBAR â”€â”€ */}
      <aside style={{ width: 250, flexShrink: 0, background: TAUPE, minHeight: "100vh",
        padding: "22px 14px", boxSizing: "border-box", overflowY: "auto",
        borderRight: "1px solid rgba(0,0,0,0.08)",
        display: isMobile ? "none" : undefined }}>

        {/* Logo YOMA */}
        <div style={{ marginBottom: 60, marginLeft: -8, marginTop: -46,
          display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <svg width="200" height="200" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
            <g fill="#A89278" fontFamily="Didot, 'Bodoni MT', 'Times New Roman', serif" fontWeight="400">
              <text x="160" y="190" fontSize="110" letterSpacing="10">Y</text>
              <text x="255" y="190" fontSize="110" letterSpacing="10">O</text>
              <line x1="125" y1="230" x2="375" y2="230" stroke="#A89278" strokeWidth="2" />
              <text x="155" y="335" fontSize="110" letterSpacing="10">M</text>
              <text x="285" y="335" fontSize="110" letterSpacing="10">A</text>
            </g>
          </svg>
          <div style={{ display: "flex", flexDirection: "column", gap: 2, marginLeft: 50, marginTop: -20 }}>
            {["Coordination", "Pilotage", "Mandat"].map(t => (
              <div key={t} style={{ fontSize: 10, fontWeight: 500, letterSpacing: "0.2em",
                textTransform: "uppercase", color: INK_SOFT }}>{t}</div>
            ))}
          </div>
        </div>

        {/* Navigation */}
        {nav.map((section) => (
          <div key={section.id}>
            <div
              onClick={() => toggleSection(section.id)}
              style={{ color: INK, fontSize: 10, fontWeight: 800, letterSpacing: "0.14em",
                textTransform: "uppercase", marginTop: 18, marginBottom: 6, padding: "5px 0",
                borderBottom: "1px solid rgba(0,0,0,0.15)", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "space-between",
                opacity: openSection === section.id ? 1 : 0.55, transition: "opacity 0.2s" }}>
              <span>{section.label}</span>
              <span style={{ fontSize: 13, fontWeight: 300 }}>{openSection === section.id ? "\u2212" : "+"}</span>
            </div>
            {openSection === section.id && (
              <div>
                {section.items.map((item) => {
                  const active = currentPageKey === item.id;
                  return (
                    <div key={item.id} onClick={() => !item.nonClickable && setActiveTab(item.id)}
                      style={{ padding: "8px 12px", borderRadius: 7, marginBottom: 2,
                        cursor: item.nonClickable ? "default" : "pointer", fontSize: 13, lineHeight: 1.35,
                        fontWeight: active ? 700 : 400,
                        color: active ? WHITE : INK,
                        background: active ? GOLD : "rgba(0,0,0,0.06)",
                        transition: "all 0.15s",
                        ...(item.style || {}) }}>
                      {item.label}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </aside>

      {/* â”€â”€ CONTENU PRINCIPAL â”€â”€ */}
      <div style={{ flex: 1, background: SOFT_BG, minHeight: "100vh",
        paddingBottom: isMobile ? 72 : 0,
        paddingTop:    (isMobile && !isOnline) ? 32 : 0 }}>

        {/* Header — masqué sur mobile (remplacé par la MobileNav) */}
        <div style={{ minHeight: 64, background: WHITE, borderBottom: `1px solid ${BORDER}`,
          display: "flex", alignItems: "center", padding: "10px 28px",
          justifyContent: "space-between", boxSizing: "border-box" }}>

          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            {projectData.companyLogo ? (
              <img src={projectData.companyLogo} alt="Logo"
                style={{ maxHeight: projectData.logoSize, maxWidth: projectData.logoSize * 2, objectFit: "contain" }} />
            ) : (
              <div style={{ fontWeight: 800, fontSize: 16, color: INK }}>
                {projectData.companyName || "YOMA DESIGN"}
              </div>
            )}
            {projectData.companyLogo && projectData.companyName && (
              <div style={{ fontWeight: 800, fontSize: 16, color: INK }}>{projectData.companyName}</div>
            )}
          </div>

          <div style={{ fontSize: 15, fontWeight: 600, color: INK_SOFT }}>
            {TAB_TITLES[currentPageKey] || ""}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: INK }}>
                {profile.full_name || profile.email}
              </div>
              <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.1em", color: GOLD }}>
                {getRoleLabel(profile.role)}
              </div>
            </div>
            <NotificationBell currentUser={currentUser} />
            <button onClick={handleLogout}
              style={{ padding: "7px 16px", background: "transparent", border: `1px solid ${BORDER}`,
                borderRadius: 7, fontSize: 12, color: INK_SOFT, cursor: "pointer" }}>
              {"D\u00e9connexion"}
            </button>
          </div>
        </div>

        {/* Page active */}
        <div style={{ padding: 24, boxSizing: "border-box", maxWidth: 1480 }}>
          {opcNeedsTypeConfig && (
            <div
              style={{
                marginBottom: 20,
                padding: "14px 18px",
                borderRadius: 10,
                background: "rgba(192,154,91,0.18)",
                border: "1px solid rgba(192,154,91,0.45)",
                fontSize: 14,
                color: INK_SOFT,
                lineHeight: 1.5,
                fontWeight: 500,
              }}
            >
              Contactez votre administrateur pour configurer votre type d&apos;accès
            </div>
          )}
          {renderPage()}
        </div>
      </div>

      {showOnboarding && profile?.role === "admin" && (
        <OnboardingModal
          userName={currentUser?.name || "Youssef"}
          onClose={(destination) => {
            setShowOnboarding(false);
            if (destination) setActiveTab(destination);
          }}
        />
      )}
      <HelpButton activeTab={activeTab} />

      {/* ── MOBILE: bandeau hors-ligne ── */}
      {isMobile && !isOnline && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
          background: "#E57373", color: "#fff", display: "flex",
          alignItems: "center", justifyContent: "center",
          fontSize: 12, fontWeight: 700, height: 32, gap: 6,
        }}>
          📡 Hors-ligne — modifications sauvegardées localement
          {unsyncedCount > 0 && ` (${unsyncedCount} en attente)`}
        </div>
      )}

      {/* ── MOBILE: Bottom Tab Bar ── */}
      {isMobile && (
        <MobileNav
          activeTab={activeTab}
          onTabChange={handleMobileTabChange}
          unsyncedCount={unsyncedCount}
        />
      )}

    </div>
  );
}